module.exports = __webpack_public_path__ + "static/media/codeKingOfTheHill2.0f43a0df.gif";